import React, { useState, useMemo, useEffect, useCallback } from "react";
import queries from "../helpers/queries";
import Select from "react-select";
import Modal from "../Components/modal";
import _ from "lodash";
// import NumPad from "react-numpad";
import AsyncSelect from "react-select/async";
import { FiPlus } from "react-icons/fi";
import moment from "moment";
import { useForm, Controller } from "react-hook-form";
import { FiEdit, FiUnlock } from "react-icons/fi";

import { useQuery, useMutation, useApolloClient } from "@apollo/react-hooks";
import { withUser } from "../Contexts/user";
import { useSidebar } from "../Contexts/sidebar";
import excel from "../Components/excel";

const statusOptions = [
    {
        label: "All",
        value: "all",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "Suspended",
        value: "suspended",
    },
];

const status = [
    {
        label: "Active",
        value: "active",
    },
    {
        label: "Suspended",
        value: "suspended",
    },
    {
        label: "Risk Suspended",
        value: "risksuspended",
    },
];

const types = [
    {
        label: "Project Director",
        value: "pd",
    },
    {
        label: "Sales Director",
        value: "sd",
    },
    {
        label: "Shareholder",
        value: "shareholder",
    },
    {
        label: "Coordinator",
        value: "agent",
    },
    {
        label: "NFC Agent",
        value: "user",
    },
    {
        label: "Admin",
        value: "admin",
    },
    {
        label: "Manager",
        value: "manager",
    },
    {
        label: "Superadmin",
        value: "superadmin",
    },
];

const gender = [
    {
        label: "Male",
        value: "male",
    },
    {
        label: "Female",
        value: "female",
    },
];

const jobType = [
    {
        label: "Full Time",
        value: "full",
    },
    {
        label: "Part Time",
        value: "part",
    },
];

const userDetailsFormFields = [
    {
        name: "name",
        label: "Full Name",
    },
    {
        name: "email",
        label: "Email",
    },
];

const formFields = [
    {
        name: "name",
        label: "Full Name",
    },


    {
        name: "email",
        label: "Email",
    },
    {
        name: "ic",
        label: "IC",
    },
    {
        name: "contact",
        label: "Contact",
    },
    {
        name: "password",
        label: "Password",
        type: "password",
    },
];

let timerId = null;

const Users = () => {
    const { isDarkMode } = useSidebar();
    const [modalData, setModalData] = useState({});
    const [createModalState, setCreateModalState] = useState(false);
    const [userDetailsState, setUserDetailsState] = useState(false);
    const [statusModalState, setStatusModalState] = useState(false);
    // const [dreampointsModalState, setDreampointsModalState] = useState(false);
    const [editModalState, setEditModalState] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [paginationState, setPaginationState] = useState({
        limit: 30,
        page: 1,
        dir: "desc",
        by: "_id",
    });

    const apollo = useApolloClient();

    const initialFilters = useMemo(
        () => ({
            name: undefined,
            code: undefined,
            status: "active",
            ranking: undefined,
            type: undefined,
            memberclub: undefined,
            state: undefined,
            risk: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            birthdayMonth: undefined,
        }),
        []
    );
    const [filters, setFilters] = useState(initialFilters);

    const [formKey, setFormKey] = useState(0);

    const initialAppliedSearchVariables = useMemo(
        () => ({
            name: undefined,
            code: undefined,
            status: "active",
            ranking: undefined,
            type: undefined,
            memberclub: undefined,
            state: undefined,
            risk: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            birthdayMonth: undefined,
        }),
        []
    );
    const [appliedSearchVariables, setAppliedSearchVariables] = useState(
        initialAppliedSearchVariables
    );

    const handleSearch = () => {
        setAppliedSearchVariables({
            name: filters.name,
            code: filters.code,
            status: filters.status,
            ranking: filters.ranking,
            type: filters.type,
            memberclub: filters.memberclub,
            state: filters.state,
            risk: filters.risk,
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            birthdayMonth: filters.birthdayMonth,
        });
        setPaginationState(prev => ({ ...prev, page: 1 }));
    };

    const {
        register,
        errors,
        handleSubmit,
        control,
        getValues,
        setValue,
        reset: resetForm,
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            type: undefined,
            password: "",
            status: undefined,
        },
    });

    useEffect(() => {
        if (editModalState) {
            const { name, type, status, password, email, ic, contact } = modalData;

            const values = [
                { name },
                {
                    userType: {
                        label: _.startCase(type),
                        value: type,
                    },
                },
                { email },
                { password },
                { status },
                { ic },
                { contact },
            ];

            setValue(values);
        }
    }, [editModalState, modalData, setValue]);

    const filterSelectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                backgroundColor: "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),
        }),
        [errors]
    );

    const memberSelect = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                backgroundColor: "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),
        }),
        [errors]
    );

    const {
        data: usersData,
        refetch: refetchUsers,
        loading: usersLoading,
    } = useQuery(queries.FETCH_USERS, {
        fetchPolicy: "network-only",
        variables: {
            limit: paginationState.limit,
            page: paginationState.page,
            dir: paginationState.dir,
            by: paginationState.by ? paginationState.by : undefined,
            name: appliedSearchVariables.name,
            code: appliedSearchVariables.code,
            status: appliedSearchVariables.status,
            ranking: appliedSearchVariables.ranking,
            type: appliedSearchVariables.type,
            memberclub: appliedSearchVariables.memberclub,
            state: appliedSearchVariables.state,
            risk: appliedSearchVariables.risk,
            dateFrom: appliedSearchVariables.dateFrom,
            dateTo: appliedSearchVariables.dateTo,
            birthdayMonth: appliedSearchVariables.birthdayMonth,
        },
        onCompleted: ({ fetchUsers: { pagination, data } }) => {
            setPaginationState(pagination);
            if (paginationState.limit === 99999) {
                alert("Export is ready");
                let payload = [];

                data.forEach((user, i) => {
                    payload.push({
                        NO: i + 1,
                        NAME: user.name,
                        TYPE: _.startCase(user.job),
                        JOINDATE: moment(user.joinDate, "x").format(
                            "DD-MM-YYYY"
                        ),
                        PRIMELEADER: user.primeleader ? user.primeleader : "",
                        ACTIVE: user.risk === "clear" ? "/" : "",
                        LEVEL0: user.risk === "lv0" ? "/" : "",
                        LEVEL1: user.risk === "lv1" ? "/" : "",
                        LEVEL2: user.risk === "lv2" ? "/" : "",
                        LEVEL3: user.risk === "lv3" ? "/" : "",
                        LEVEL4: user.risk === "lv4" ? "/" : "",
                        LEVEL5: user.risk === "lv5" ? "/" : "",
                        LEVEL6: user.risk === "lv6" ? "/" : "",
                        RESIGN: user.status === "resign" ? "/" : "",
                    });
                });

                excel({
                    excelData: payload,
                    fileName: `Users-export-data`,
                });
            }
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const resetCreateModal = () => {
        setCreateModalState(false);
        setModalData({});
        resetForm();
    };

    const resetUserDetailsModal = () => {
        setUserDetailsState(false);
        setModalData({});
        resetForm();
    };

    const resetEditModal = () => {
        setEditModalState(false);
        setModalData({});
        resetForm();
    };

    const resetStatusModal = () => {
        setStatusModalState(false);
        setModalData({});
        resetStatusForm();
    };

    // const resetDreamPointsModal = () => {
    //   setDreampointsModalState(false);
    //   setModalData({});
    // };

    useEffect(() => {
        if (userDetailsState) {
            const { _id, name, email, ic, contact, type, status } = modalData;
            setValue([
                { _id },
                { name },
                { email },
                { ic },
                { contact },
                {
                    type: type
                        ? {
                              label: _.startCase(type),
                              value: type,
                          }
                        : undefined,
                },
                {
                    status: status
                        ? {
                              label: _.startCase(status),
                              value: status,
                          }
                        : undefined,
                },
            ]);
        }
    }, [userDetailsState, modalData, setValue]);

    const [createUser] = useMutation(queries.CREATE_USER, {
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    alert(graphQLError.message);
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const [editUserDetails] = useMutation(queries.EDIT_USER_DETAILS);

    const handleUserDetails = async () => {
        try {
            const formValues = getValues();

            const result = await editUserDetails({
                variables: {
                    userId: modalData._id,
                    name: formValues.name,
                    email: formValues.email,
                    type: formValues.type?.value,
                    password: formValues.password,
                    status: formValues.status?.value,
                },
            });

            if (result.data) {
                setUserDetailsState(false);
                resetForm();
                refetchUsers();
                alert("Success");
            }
        } catch (err) {
            alert("Failed");
            console.log(err);
        }
    };

    const handleCreateUser = async () => {
        try {
            const formValues = getValues();

            const result = await createUser({
                variables: {
                    name: formValues.name,
                    email: formValues.email,
                    type: formValues.type.value,
                    password: formValues.password,
                    ic: formValues.ic,
                    contact: formValues.contact,
                },
            });

            if (result.error) {
                alert("Failed");
            }

            if (result.data) {
                // do success stuff
                resetCreateModal();
                refetchUsers();
                alert("Success");
            }
        } catch (err) {
            //do err stuff
            alert("Failed");
            console.log(err);
        }
    };

    const [updateStatus] = useMutation(queries.UPDATE_USER_STATUS);

    const handleUpdateUserStatus = async () => {
        const formValues = getValuesStatusForm();

        await updateStatus({
            variables: {
                id: modalData._id,
                status: formValues.userStatus
                    ? formValues.userStatus.value
                    : modalData.status,
            },
            onError: ({ graphQLErrors, networkError }) => {
                if (graphQLErrors) {
                    for (const graphQLError of graphQLErrors) {
                        console.log(graphQLError);
                    }
                }

                if (networkError) {
                    console.log(networkError);
                }
            },
        });

        alert("Success");
        refetchUsers();
        setStatusModalState(false);
        setModalData({});
    };
    const {
        getValues: getValuesStatusForm,
        setValue: setValueStatusForm,
        reset: resetStatusForm,
        control: statusFormControl,
    } = useForm({
        defaultValues: {
            status: null,
            state: null,
            joinDate: "",
            resignDate: "",
        },
    });

    useEffect(() => {
        if (statusModalState) {
            const { _id } = modalData;
            setValueStatusForm([
                {
                    userStatus: {
                        label: _.startCase(modalData.status),
                        value: modalData.status,
                    },
                },
                { _id },
            ]);
        }
    }, [statusModalState, modalData, setValueStatusForm]);

    const [editUser] = useMutation(queries.EDIT_USER);

    const handleEditUser = async () => {
        try {
            const formValues = getValues();

            const result = await editUser({
                variables: {
                    userId: modalData._id,
                    name: formValues.name,
                    email: formValues.email,
                    type: formValues.userType.value,
                    password: formValues.password,
                    ic: formValues.ic,
                    contact: formValues.contact,
                },
            });

            if (result.error) {
                alert("Failed");
            }

            if (result.data) {
                // do success stuff
                resetEditModal();
                refetchUsers();
                alert("Success");
            }
        } catch (err) {
            //do err stuff
            alert("Failed");
            console.log(err);
        }
    };

    const loadUsers = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item.name,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    return (
        <div
            className={`min-h-screen ${
                isDarkMode ? "bg-gray-900" : "bg-gray-50"
            }`}
        >
            <div className="px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : ''}`}>Users</h1>
                <button
                    onClick={() => setCreateModalState(true)}
                    className={`flex items-center px-4 py-2 rounded text-white ${
                        isDarkMode
                            ? "bg-blue-600 hover:bg-blue-500"
                            : "bg-blue-500 hover:bg-blue-600"
                    }`}
                >
                    <FiPlus className="mr-2" />
                    Add User
                </button>
            </div>
            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow p-4 mb-6 border`} key={formKey}>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Name
                        </label>
                        <AsyncSelect
                            styles={filterSelectStyles}
                            isSearchable={true}
                            loadOptions={loadUsers}
                            placeholder="Select Name"
                            isClearable={true}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    name: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            User Type
                        </label>
                        <AsyncSelect
                            styles={filterSelectStyles}
                            isSearchable={false}
                            defaultOptions={[
                                {
                                    label: "All",
                                    value: "all",
                                },
                                ...types,
                            ]}
                            placeholder="Select Type"
                            isClearable={true}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    type: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Birthday Month
                        </label>
                        <AsyncSelect
                            styles={filterSelectStyles}
                            isSearchable={false}
                            defaultOptions={[
                                {
                                    label: "January",
                                    value: "1",
                                },
                                {
                                    label: "February", 
                                    value: "2",
                                },
                                {
                                    label: "March",
                                    value: "3", 
                                },
                                {
                                    label: "April",
                                    value: "4",
                                },
                                {
                                    label: "May",
                                    value: "5",
                                },
                                {
                                    label: "June",
                                    value: "6",
                                },
                                {
                                    label: "July",
                                    value: "7",
                                },
                                {
                                    label: "August",
                                    value: "8",
                                },
                                {
                                    label: "September",
                                    value: "9",
                                },
                                {
                                    label: "October",
                                    value: "10",
                                },
                                {
                                    label: "November",
                                    value: "11",
                                },
                                {
                                    label: "December",
                                    value: "12",
                                }
                            ]}
                            placeholder="Select Month"
                            isClearable={true}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    birthdayMonth: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Status
                        </label>
                        <AsyncSelect
                            styles={filterSelectStyles}
                            isSearchable={false}
                            defaultOptions={statusOptions}
                            placeholder="Select Status"
                            isClearable={true}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    status: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div className="flex items-end gap-2 mb-4 flex-shrink-0">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className={`px-4 py-2 rounded text-white ${
                                isDarkMode
                                    ? "bg-blue-600 hover:bg-blue-500"
                                    : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        >
                            Search
                        </button>
                        <button
                            onClick={() => {
                                setFilters(initialFilters);
                                setAppliedSearchVariables(
                                    initialAppliedSearchVariables
                                );
                                // Reset form fields
                                resetForm();
                                // Force re-render of form to clear dropdowns
                                setFormKey(prev => prev + 1);
                            }}
                            className={`px-4 py-2 rounded text-white ${
                                isDarkMode
                                    ? "bg-gray-600 hover:bg-gray-500"
                                    : "bg-gray-500 hover:bg-gray-600"
                            }`}
                        >
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>

      
            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow overflow-hidden border overflow-x-auto`}>
                {usersLoading ? (
                    <div className="flex flex-col items-center justify-center py-24 px-4">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                            Loading users...
                        </p>
                        <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                            Please wait
                        </p>
                    </div>
                ) : (
                <>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className={`text-black`}>
                        <tr className="bg-orange-400">
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Name
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                IC
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Contact
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                DOB
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Email
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Type
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Status
                            </th>
                            <th className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}>
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} divide-y divide-gray-200`}>
                        {usersData?.fetchUsers?.data?.length > 0 ? usersData.fetchUsers.data.map((user) => (
                            <tr key={user._id} className={`${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{user.name}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{user.ic}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{user.contact}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {user.dob ? (() => {
                                        const date = new Date(user.dob);
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const year = date.getFullYear();
                                        return `${day}-${month}-${year}`;
                                    })() : null}
                                </td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{user.email}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                    {user.type === "agent"
                                        ? "Property Agent"
                                        : user.type === "user"
                                        ? "NFC Agent"
                                        : user.type === "pd"
                                        ? "Project Director"
                                        : user.type === "sd"
                                        ? "Sales Director"
                                        : user.type === "shareholder"
                                        ? "Shareholder"
                                        : user.type === "admin"
                                        ? "Admin"
                                        : user.type === "superadmin"
                                        ? "Superadmin"
                                        : user.type === "manager"
                                        ? "Manager"
                                        : "Shareholder"}
                                </td>
                                <td className="px-6 py-4">
                                    <span
                                        className={
                                            user.status === "active"
                                                ? "text-green-600"
                                                : "text-red-600"
                                        }
                                    >
                                        {user.status?.charAt(0).toUpperCase() +
                                            user.status?.slice(1)}
                                    </span>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() => {
                                                setEditModalState(true);
                                                setModalData(user);
                                            }}
                                            className="text-orange-400 hover:text-orange-600"
                                        >
                                            <FiEdit />
                                        </button>
                                        <button
                                            onClick={() => {
                                                setModalData(user);
                                                setStatusModalState(true);
                                            }}
                                            className="text-orange-400 hover:text-orange-600"
                                        >
                                            <FiUnlock />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="8" className={`px-6 py-4 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                    No users found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {usersData && usersData.fetchUsers.pagination && (
                    <div className={`px-4 py-3 flex items-center justify-between border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <div className="flex-1 flex justify-between items-center">
                            <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Showing{' '}
                                <span className="font-medium">
                                    {((paginationState.page - 1) * paginationState.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(paginationState.page * paginationState.limit, usersData.fetchUsers.pagination.documents)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{usersData.fetchUsers.pagination.documents}</span>
                                {' '}results
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    First
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className={`px-3 py-1 rounded-md text-sm font-medium ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-900'}`}>
                                    Page {paginationState.page} of {usersData.fetchUsers.pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={paginationState.page === usersData.fetchUsers.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === usersData.fetchUsers.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: usersData.fetchUsers.pagination.totalPages }))}
                                    disabled={paginationState.page === usersData.fetchUsers.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === usersData.fetchUsers.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Last
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </>
                )}
            </div>
            {editModalState && (
                <Modal reset={resetEditModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className={`mb-4 text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                Edit User
                            </div>
                            <form
                                onSubmit={handleSubmit(handleEditUser)}
                                className="lg:w-104"
                            >
                                {formFields.map((item, i) => {
                                    if (item.type === "prefixed") {
                                        return (
                                            <div key={item.name}>
                                                <div className="mb-2 text-sm text-lynch font-medium">
                                                    {item.label}
                                                </div>
                                                <div className="flex items-center">
                                                    <div
                                                        style={{
                                                            padding: "0.6rem",
                                                        }}
                                                        className="bg-gray-300 rounded-l-lg"
                                                    >
                                                        DD
                                                    </div>
                                                    <input
                                                        className={`my-2 p-3 w-full rounded-r-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                                            errors[item.name]
                                                                ? "border-red-400"
                                                                : "border-gray-300"
                                                        }`}
                                                        name={item.name}
                                                        ref={register({
                                                            required: false,
                                                        })}
                                                        placeholder={item.label}
                                                        type={
                                                            item.type
                                                                ? item.type
                                                                : "text"
                                                        }
                                                    />
                                                </div>
                                                {errors[item.name] && (
                                                    <p className="text-red-400 text-xs">{`${item.label} cannot be empty`}</p>
                                                )}
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={item.name}>
                                            <div
                                                className={`mb-2 text-sm text-lynch font-medium flex items-center justify-between ${
                                                    item.type === "hiddenEdit"
                                                        ? "hidden"
                                                        : ""
                                                }`}
                                            >
                                                {item.label}
                                                {item.type === "password" && (
                                                    <button
                                                        type="button"
                                                        className="text-gray-500 hover:text-gray-700 text-sm"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                    >
                                                        {showPassword ? "Hide" : "Show"}
                                                    </button>
                                                )}
                                            </div>
                                            {item.type === "password" ? (
                                                <input
                                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                                        isDarkMode 
                                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                            : 'bg-cool-gray border-gray-300 text-lynch'
                                                    } ${
                                                        item.type === "hiddenEdit"
                                                            ? "hidden"
                                                            : ""
                                                    } ${
                                                        errors[item.name]
                                                            ? "border-red-400"
                                                            : ""
                                                    }`}
                                                    name={item.name}
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    placeholder={item.label}
                                                    type={showPassword ? "text" : "password"}
                                                />
                                            ) : (
                                                <input
                                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                                        isDarkMode 
                                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                            : 'bg-cool-gray border-gray-300 text-lynch'
                                                    } ${
                                                        item.type === "hiddenEdit"
                                                            ? "hidden"
                                                            : ""
                                                    } ${
                                                        errors[item.name]
                                                            ? "border-red-400"
                                                            : ""
                                                    }`}
                                                    name={item.name}
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    placeholder={item.label}
                                                    type={
                                                        item.type
                                                            ? item.type
                                                            : "text"
                                                    }
                                                />
                                            )}
                                            {errors[item.name] && (
                                                <p className="text-red-400 text-xs">{`${item.label} cannot be empty`}</p>
                                            )}
                                        </div>
                                    );
                                })}

                                <div className="w-full">
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        User Type
                                    </div>
                                    <Controller
                                        as={<Select styles={memberSelect} />}
                                        name="userType"
                                        control={control}
                                        rules={{ required: true }}
                                        options={types}
                                    />
                                    {errors.userType && (
                                        <p className="text-red-400 text-xs">
                                            User Type cannot be empty
                                        </p>
                                    )}
                                </div>
                                <button className="mt-4 py-3 text-sm rounded-lg w-full bg-orange-500 bg-opacity-75 hover:bg-orange-700 transition-all duration-200 block text-white">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            {statusModalState && (
                <Modal reset={resetStatusModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className={`mb-4 text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                Status
                            </div>
                            <form
                                onSubmit={handleSubmit(handleUpdateUserStatus)}
                                className="lg:w-104"
                            >
                                <>
                                    <div className={`mb-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Status
                                    </div>
                                    <Controller
                                        as={
                                            <Select
                                                styles={memberSelect}
                                                isSearchable={false}
                                            />
                                        }
                                        name="userStatus"
                                        className="mb-2"
                                        control={statusFormControl}
                                        rules={{ required: true }}
                                        options={status}
                                    />
                                    {errors.userStatus && (
                                        <p className="text-red-400 text-xs">{`Status cannot be empty`}</p>
                                    )}
                                </>

                                <button className="mt-4 py-3 text-sm rounded-lg w-full bg-orange-500 bg-opacity-75 hover:bg-orange-700 transition-all duration-200 block text-white">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            {createModalState && (
                <Modal reset={resetCreateModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className={`mb-4 text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                New User
                            </div>
                            <form
                                onSubmit={handleSubmit(handleCreateUser)}
                                className="lg:w-104"
                            >
                                {formFields.map((item, i) => {
                                    if (item.type === "prefixed") {
                                        return (
                                            <div key={item.name}>
                                                <div className={`mb-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                                    {item.label}
                                                </div>
                                                <div className="flex items-center">
                                                    <div
                                                        style={{
                                                            padding: "0.6rem",
                                                        }}
                                                        className="bg-gray-300 rounded-l-lg"
                                                    >
                                                        DD
                                                    </div>
                                                    <input
                                                        className={`my-2 p-3 w-full rounded-r-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                                            errors[item.name]
                                                                ? "border-red-400"
                                                                : "border-gray-300"
                                                        }`}
                                                        name={item.name}
                                                        ref={register({
                                                            required: false,
                                                        })}
                                                        placeholder={item.label}
                                                        type={
                                                            item.type
                                                                ? item.type
                                                                : "text"
                                                        }
                                                    />
                                                </div>
                                                {errors[item.name] && (
                                                    <p className="text-red-400 text-xs">{`${item.label} cannot be empty`}</p>
                                                )}
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={item.name}>
                                            <div
                                                className={`mb-2 text-sm font-medium flex items-center justify-between ${
                                                    item.type === "hiddenEdit"
                                                        ? "hidden"
                                                        : ""
                                                } ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}
                                            >
                                                {item.label}
                                                {item.type === "password" && (
                                                    <button
                                                        type="button"
                                                        className={`text-sm ${isDarkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}
                                                        onClick={() => setShowPassword(!showPassword)}
                                                    >
                                                        {showPassword ? "Hide" : "Show"}
                                                    </button>
                                                )}
                                            </div>
                                            {item.type === "password" ? (
                                                <input
                                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                                        isDarkMode 
                                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                            : 'bg-cool-gray border-gray-300 text-lynch'
                                                    } ${
                                                        item.type === "hiddenEdit"
                                                            ? "hidden"
                                                            : ""
                                                    } ${
                                                        errors[item.name]
                                                            ? "border-red-400"
                                                            : ""
                                                    }`}
                                                    name={item.name}
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    placeholder={item.label}
                                                    type={showPassword ? "text" : "password"}
                                                />
                                            ) : (
                                                <input
                                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                                        isDarkMode 
                                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                            : 'bg-cool-gray border-gray-300 text-lynch'
                                                    } ${
                                                        item.type === "hiddenEdit"
                                                            ? "hidden"
                                                            : ""
                                                    } ${
                                                        errors[item.name]
                                                            ? "border-red-400"
                                                            : ""
                                                    }`}
                                                    name={item.name}
                                                    ref={register({
                                                        required: false,
                                                    })}
                                                    placeholder={item.label}
                                                    type={
                                                        item.type
                                                            ? item.type
                                                            : "text"
                                                    }
                                                />
                                            )}
                                            {errors[item.name] && (
                                                <p className="text-red-400 text-xs">{`${item.label} cannot be empty`}</p>
                                            )}
                                        </div>
                                    );
                                })}
                                <div>
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Type
                                    </div>
                                    <Controller
                                        as={
                                            <Select
                                                styles={memberSelect}
                                                isSearchable={false}
                                            />
                                        }
                                        name="type"
                                        control={control}
                                        rules={{ required: false }}
                                        options={types}
                                    />
                                    {errors.type && (
                                        <p className="text-red-400 text-xs">
                                            Type cannot be empty
                                        </p>
                                    )}
                                </div>
                                <button className="mt-4 py-3 text-sm rounded-lg w-full bg-orange-500 bg-opacity-75 hover:bg-orange-700 transition-all duration-200 block text-white">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            {userDetailsState && (
                <Modal reset={resetUserDetailsModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className={`mb-4 text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                User Details
                            </div>
                            <form
                                onSubmit={handleSubmit(handleUserDetails)}
                                className="lg:w-104"
                            >
                                {userDetailsFormFields.map((item, i) => (
                                    <div key={item.name}>
                                        <div className={`mb-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                            {item.label}
                                        </div>
                                        <input
                                            className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                    : 'bg-cool-gray border-gray-300 text-lynch'
                                            } ${
                                                errors[item.name]
                                                    ? "border-red-400"
                                                    : ""
                                            }`}
                                            name={item.name}
                                            ref={register({ required: true })}
                                            placeholder={item.label}
                                        />
                                        {errors[item.name] && (
                                            <p className="text-red-400 text-xs">{`${item.label} cannot be empty`}</p>
                                        )}
                                    </div>
                                ))}
                                <div>
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Job Type
                                    </div>
                                    <Controller
                                        as={
                                            <Select
                                                styles={memberSelect}
                                                isSearchable={false}
                                            />
                                        }
                                        name="job"
                                        control={control}
                                        rules={{ required: false }}
                                        options={jobType}
                                    />
                                    {errors.job && (
                                        <p className="text-red-400 text-xs">
                                            Job cannot be empty
                                        </p>
                                    )}
                                </div>
                                <div>
                                    <div className={`my-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-lynch'}`}>
                                        Gender
                                    </div>
                                    <Controller
                                        as={
                                            <Select
                                                styles={memberSelect}
                                                isSearchable={false}
                                            />
                                        }
                                        name="gender"
                                        control={control}
                                        rules={{ required: false }}
                                        options={gender}
                                    />
                                    {errors.gender && (
                                        <p className="text-red-400 text-xs">
                                            Gender cannot be empty
                                        </p>
                                    )}
                                </div>
                                <button className="mt-4 py-3 text-sm rounded-lg w-full bg-orange-500 bg-opacity-75 hover:bg-orange-700 transition-all duration-200 block text-white">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            </div>
        </div>
    );
};

export default withUser(Users);
